import React from "react";
import { PanelEditMarketer } from "../../../UI/Marketers/Edit/PanelEditMarketer";

const EditMarketer = () => {
  return (
    <div>
      <PanelEditMarketer />
    </div>
  );
};

export default EditMarketer;
